import React, { FC, useState } from 'react';
import { Moment } from 'moment';
import { useTranslations } from '@lang';
import { Button } from '@common/components';
import { DatePicker as DatePickerComp } from '../Filters/DatePicker';
import { MobileModal } from '../MobileModal';
import {
  FiltersWrapper,
  ClassFiltersWrapper,
  ButtonClassFiltersColumn,
} from '../Filters/Filters.styles';

type DateCategoryPickerProps = {
  fromDate: Moment;
  onDateChange: (any) => void;
  handleUpdate: () => void;
};

export const DatePicker: FC<DateCategoryPickerProps> = ({
  fromDate,
  onDateChange,
  handleUpdate,
}) => {
  const { t } = useTranslations();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleMobileUpdate = () => {
    setIsModalOpen(false);
    handleUpdate();
  };
  return (
    <MobileModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}>
      <FiltersWrapper>
        <ClassFiltersWrapper>
          <DatePickerComp showDatesPicker fromDate={fromDate} onDateChange={onDateChange} />
          <ButtonClassFiltersColumn>
            <Button onClick={() => handleMobileUpdate()}>{t('spaClasses.update')}</Button>
          </ButtonClassFiltersColumn>
        </ClassFiltersWrapper>
      </FiltersWrapper>
    </MobileModal>
  );
};
